import { render, staticRenderFns } from "./UserNotificatio.vue?vue&type=template&id=c232b1f6&scoped=true&"
import script from "./UserNotificatio.vue?vue&type=script&lang=js&"
export * from "./UserNotificatio.vue?vue&type=script&lang=js&"
import style0 from "./UserNotificatio.vue?vue&type=style&index=0&id=c232b1f6&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c232b1f6",
  null
  
)

export default component.exports